// extracted by mini-css-extract-plugin
module.exports = {"submit-row":"styles_submit-row__lLpD3","submit-row__btn":"styles_submit-row__btn__5Hxlh"};